module.exports = __webpack_public_path__ + "img/gb9115_2.prt.340e39af.jpg";